import React, { useState } from "react";
import { FixedSizeList as List } from "react-window";
import NoSearchResult from "../../orders/NoSearchResult";
import { IListItem } from "../types.d";
import { OrderListItem } from "../../orders/OrderList/OrderListItem";
import { ListItemsLoading } from "./Loading";
import {useStyles} from "./styles"

interface ICustomersListProps {
    itemList: IListItem[] | any[];
    columns: any;
    listHeight?: number;
    className?: string;
    itemSize?: number;
    isLoading?: boolean;
    emptyListTitle: string;
    emptyListInfo?: string;
    onSelectItem: Function;
}

export function CustomersList({
    itemList,
    columns,
    className,
    isLoading,
    emptyListTitle,
    emptyListInfo,
    onSelectItem
}: ICustomersListProps) {
    const [windowHeight] = useState(calculateListHeight());
    const classes = useStyles();
    function Row({ index, style }: any) {
        const item = itemList[index];
        return (
            <div style={style} key={index} data-component-name="CustomersItem">
                <OrderListItem order={item as any} columns={columns}
                    className={className}
                    onClickItem={() => onSelectItem(itemList[index])}
                    props={item}
                />
            </div>
        );
    }
    if (isLoading) {
        return <ListItemsLoading />;
    }
    return itemList.length > 0 ? <div className={classes.listWrapper}>
        <List height={windowHeight}
            itemCount={itemList.length}
            itemSize={window.innerWidth>768 ? 80 : 100}
            width={"100%"}
            style={{
                paddingBottom: "3.5rem",
                overflow: "auto",
            }}
        >
            {Row}
        </List>
    </div> : <NoSearchResult title={emptyListTitle} info={emptyListInfo} />;
}

/**calculates the list height */
function calculateListHeight() {
    const windowheight = window.innerHeight - 125;
    return windowheight;
}